import React from 'react';

import Alert from '@storeblocks/alert';
import Button from '@storeblocks/button';
import LoadingIndicator from '@storeblocks/loading-indicator';
import { useInsuranceDetailsWithPotentialChanges } from 'Api/insurance';
import {
  WrapLgMarginBottom,
  WrapMdMarginBottom,
  WrapSmMarginBottom,
} from 'App/global-style';
import { BuyHouseContentButton } from 'Components/InsuranceDetailsSections/components/InsuranceViewButtons/BuyHouseContentButton';
import { CancelButton } from 'Components/InsuranceDetailsSections/components/InsuranceViewButtons/CancelButton';
import { PageContentWrapper } from 'Components/PageContentWrapper';
import { PageHeader } from 'Components/PageHeader';
import { NavLink, useNavigate, useParams } from 'react-router';
import { isAnyHouseContentsProduct } from 'Utils/insuranceTypes';
import { getAppText } from 'Utils/text';

export const ChangeAddressPage = (): React.ReactElement => {
  const navigate = useNavigate();
  const { policyNumber = '' } = useParams<{ policyNumber: string }>();

  const {
    insuranceDetailsWithPotentialChanges: insuranceDetails,
    loading,
    error,
  } = useInsuranceDetailsWithPotentialChanges(policyNumber);

  if (loading) {
    return (
      <PageContentWrapper>
        <LoadingIndicator />
      </PageContentWrapper>
    );
  }

  if (error || !insuranceDetails) {
    return (
      <PageContentWrapper>
        <Alert
          variant="error"
          title={getAppText('misc.error.fetchInsuranceDetailed.title')}
          description={getAppText(
            'misc.error.fetchInsuranceDetailed.description',
          )}
        />
      </PageContentWrapper>
    );
  }

  const { insuranceProduct, agreementProduct } = insuranceDetails;

  if (!isAnyHouseContentsProduct(insuranceProduct)) {
    return (
      <PageContentWrapper>
        <Alert
          variant="error"
          title={getAppText('changeAddress.page.error.title')}
        >
          <NavLink key="overviewInsurance" to="/" reloadDocument>
            {getAppText('changeAddress.page.error.text')}
          </NavLink>
        </Alert>
      </PageContentWrapper>
    );
  }

  return (
    <>
      <PageHeader
        currentPage="change"
        pageTitle={getAppText('changeAddress.page.title')}
      />
      <WrapLgMarginBottom>
        <h2>{getAppText('changeAddress.page.firstHeading')}</h2>
      </WrapLgMarginBottom>

      <WrapSmMarginBottom>
        <h3>{getAppText('changeAddress.page.buyInsuranceHeading')}</h3>
        <p>{getAppText('changeAddress.page.buyInsuranceText')}</p>
      </WrapSmMarginBottom>
      <WrapLgMarginBottom>
        <BuyHouseContentButton
          insuranceProduct={insuranceProduct}
          agreementCode={agreementProduct}
          disabled={false}
        />
      </WrapLgMarginBottom>

      <WrapSmMarginBottom>
        <h3>{getAppText('changeAddress.page.cancelInsuranceHeading')}</h3>
        <p>{getAppText('changeAddress.page.cancelInsuranceText')}</p>
      </WrapSmMarginBottom>
      <WrapLgMarginBottom>
        <CancelButton
          policyNumber={policyNumber}
          insuranceProduct={insuranceProduct}
          disabled={false}
        />
      </WrapLgMarginBottom>

      <WrapMdMarginBottom>
        <Button
          iconLeft="arrow-left"
          variant="text"
          onClick={() => navigate(-1)}
        >
          {getAppText('changeAddress.button.back.label')}
        </Button>
      </WrapMdMarginBottom>
    </>
  );
};

export default ChangeAddressPage;
